<template>
    <div>
        <vue-simple-spinner v-if="processing"></vue-simple-spinner>
        <notifications group="foo" />
        <div v-if="webinarProcessed">
            <div v-if="webinar === undefined">
                <h3 class="text-center">Transmisja zakończyła się</h3>
            </div>
            <div v-else>
                <div v-if="isLive"  class="subpage--transmission"> 
                    <section>
                            <div class="subpage__heading-section">
                                <h2 class="subpage__heading">{{ this.otherIsLargeAuditorium ? 'Transmisja Sala 2' : 'Transmisja Sala 1' }}</h2>
                            </div>
                            <!-- <div class="my-5" v-html="webinar.content"></div> -->
                            <div class="mb-5" v-if="webinar.live_note">
                                <p class="mb-0" v-html="webinar.live_note"></p>
                            </div>
                        <div class="bg-gradient">
                            
                            <div class="video-chat-wrapper">
                                    <div class="video-wrapper" v-if="webinar.video_url">
                                        <iframe class="video" id="vimeo-iframe" :src="webinar.video_url" frameborder="0" allow="autoplay; fullscreen" allowfullscreen="" data-ready="true"></iframe>
                                    </div>
                                    <div  class="video-wrapper" v-else>
                                        <h3>Prosimy odświezyć stronę</h3>
                                    </div>
                                <div class="chat-wrapper" v-if="webinar.is_chat_enabled">
                                    <chat :webinar_uuid="webinar.uuid" :user_id="user_id" :chat_name="chat_name" :is_admin="is_admin"></chat>
                                </div>

                                <div v-if="otherWebinar.id !== webinar.id" class="other-webinar-button-wrapper">
                                    <strong>Transmisja sala {{ this.otherIsLargeAuditorium ? '2' : '1' }}</strong>
                                    <a v-bind:href="'/ogladaj/' + otherWebinar.id + '/' + otherWebinar.uuid">
                                        Przejdź do transmisji z {{ this.otherIsLargeAuditorium ? 'Sali 1' : 'Sali 2' }}
                                    </a>
                                </div>
                            </div>
                            <div class="bottom-gradient"></div>
                    </div>
                    </section>
                    
                    <!-- <div class="bottom-gradient"></div> -->
                    <!-- <div v-if="otherWebinar.id !== webinar.id" class="container d-flex justify-content-center">
                        <a v-bind:href="'/ogladaj/' + otherWebinar.id + '/' + otherWebinar.uuid" class="btn video-btn">
                            Przejdź do transmisji z {{ this.otherIsLargeAuditorium ? 'Sali 1' : 'Sali 2' }}
                        </a>
                    </div> -->
                </div>
                <div v-else class="subpage--transmission">
                    <!-- <section class="m-md-5"> -->
                    <section>
                        <div class="subpage__heading-section">
                            <h2 class="subpage__heading">{{ this.otherIsLargeAuditorium ? 'Transmisja Sala 2' : 'Transmisja Sala 1' }}</h2>
                        </div>
                        <div class="my-5" v-html="webinar.content"></div>
                        <div class="mb-5" v-if="webinar.live_note">
                            <p class="mb-0" v-html="webinar.live_note"></p>
                        </div>
                        <!-- <div class="embed-responsive embed-responsive-16by9">
                            <div class="card-img-overlay badge-secondary text-sm-center display-2" style="padding-top:25%" id="vimeo-iframe" v-html="timer"></div>
                        </div> -->
                        <div class="timer-wrapper">
                            <p v-html="timer"></p>
                        </div>
                    </section>
                    <!-- <div v-if="otherWebinar.id !== webinar.id" class="container d-flex justify-content-center"> -->
                    <div class="other-webinar-button-wrapper">
                        <a v-bind:href="'/ogladaj/' + otherWebinar.id + '/' + otherWebinar.uuid">
                            Przejdź do transmisji z {{ this.otherIsLargeAuditorium ? 'Sali 1' : 'Sali 2' }}
                        </a>
                    </div>
                    <div class="bottom-gradient"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import Spinner from "vue-simple-spinner";

export default {
    props: ['user_id', 'is_admin', 'chat_name', 'webinar_id', 'webinar_uuid'],
    components: {
        Spinner
    },
    data() {
        return {
            webinarId: this.webinar_id,
            webinarUuid: this.webinar_uuid,
            webinar: {},
            webinarProcessed: false,
            processing: true,
            timer: null,
            isMarked: false,
            isOther: false,
            otherWebinar: {},
            otherIsLargeAuditorium: false
        }
    },
    mounted() {
        this.getWebinar();
        this.getOtherWebinar();
        var self = this;
        if(self.timer != 'Zapraszamy') {
            setInterval(function () {
                if (self.webinar) {
                    var diffInSeconds = Math.abs(new Date() - new Date(self.webinar.video_start_date)) / 1000;
                    var hours = parseInt(diffInSeconds / 60 / 60);
                    var minutes = parseInt(diffInSeconds / 60 % 60);
                    var seconds = parseInt(diffInSeconds % 60)
                    self.timer = self.formatHour(hours) + ':' + self.formatTime(minutes) + ':' + self.formatTime(seconds);
                    if (self.timer === '00:00:00' || new Date() > new Date(self.webinar.video_start_date)) {
                        self.timer = 'Zapraszamy';
                    }
                }
            }, 1000);
        }
    },
    computed: {
        isLive() {
            if(this.webinar.video_start_date && this.timer !== null ) {
                var date = new Date(this.webinar.video_start_date);
                if(new Date() >= date || this.timer < new Date()) {
                    if(this.isMarked === false) {
                        axios.post('/api/webinars/' + this.webinar.id + '/mark-attendance');
                        this.isMarked = true;
                    }

                    return true;
                }
            }

            return false;
        }
    },
    methods: {
        getWebinar() {
            axios.post('/api/webinars/get-current', {
                webinarId: this.webinarId,
                webinarUuid: this.webinarUuid
            }).then(response => {
                this.webinar = response.data.data;
                this.webinarProcessed = true;
                this.processing = false;
            });
        },
        getOtherWebinar() {
            axios.post('/api/webinars/get-other', {
                webinarId: this.webinarId,
                webinarUuid: this.webinarUuid
            }).then(response => {
                console.log(response);
                this.isOther = true;
                this.otherWebinar = response.data.webinar;
                // console.log(this.otherWebinar);
                this.otherIsLargeAuditorium = response.data.isLargeAuditorium;
                // console.log(this.otherWebinar);
            });
        },
        formatTime(time)
        {
            return ('0' + time).slice(-2);
        },

        formatHour(hours)
        {
            if(hours<10){
                return '0' + hours;
            }
            return hours;
        }
    }
}
</script>
